<template>
  <div class="vx-row" id="vouchers">
    <div class="vx-col w-full">
      <vx-card>
        <form>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx"
                v-model="model.prefix"
                name="prefix"
                :label="$t('Prefix')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('prefix')">{{
                errors.first("prefix")
              }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx"
                v-model="model.title"
                name="title"
                :label="$t('Title')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('title')">{{
                errors.first("title")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("StartDate")
              }}</label>
              <date-picker
                v-model="model.expirationInfo.startClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                id="date-picker"
                :label="$t('StartDate')"
                name="startDate"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('startDate')"
                >{{ errors.first("startDate") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("EndDate")
              }}</label>
              <date-picker
                v-model="model.expirationInfo.expireClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                id="date-picker"
                :label="$t('EndDate')"
                name="expireDate"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('expireDate')"
                >{{ errors.first("expireDate") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx"
                v-model="model.discountLimitation.minimumBasketAmount"
                name="minAmount"
                :label="$t('MinimumBasketAmount')"
                v-validate="{ regex: '^([0-9]+)$' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('minAmount')"
                >{{ errors.first("minAmount") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx"
                v-model="model.discountLimitation.maximumBasketAmount"
                name="maxAmount"
                :label="$t('MaximumBasketAmount')"
                v-validate="{ regex: '^([0-9]+)$' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('maxAmount')"
                >{{ errors.first("maxAmount") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx mb-4 mt-1"
                v-model="model.discountLimitation.minimumNumberOfItemsInBasket"
                name="minItems"
                :label="$t('MinimumNumberOfItemsInBasket')"
                v-validate="{ regex: '^([0-9]+)$' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('minItems')"
                >{{ errors.first("minItems") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx mt-1"
                v-model="model.discountLimitation.maximumNumberOfItemsInBasket"
                name="maxItems"
                :label="$t('MaximumNumberOfItemsInBasket')"
                v-validate="{ regex: '^([0-9]+)$' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('maxItems')"
                >{{ errors.first("maxItems") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">{{ $t("CalculationType") }}</label>
              <v-select
                label="name"
                name="calculationType"
                :options="calculationTypes"
                v-model="model.discountType"
                v-validate="{ required: true }"
                :reduce="(x) => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('calculationType')"
                >{{ errors.first("calculationType") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="inputx mt-1"
                v-model="model.discountAmount"
                name="discountAmount"
                :label="$t('DiscountAmount')"
                v-validate="{ required: 'true', regex: '^([0-9]+)$' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('discountAmount')"
                >{{ errors.first("discountAmount") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-checkbox v-model="model.isItCalculatedForAnAmazingDiscount">{{
                $t("CalculatedForAnAmazingDiscount")
              }}</vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitForm"
                >{{ $t("Save") }}</vs-button
              >
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
#vouchers #date-picker label {
  width: 115px;
}
</style>
<script>
import { mapActions } from "vuex";

import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    prefix: {
      required: "لطفا پیشوند را وارد نمایید.",
    },
    title: {
      required: "لطفا عنوان را وارد نمایید.",
    },
    startDate: {
      required: "لطفا تاریخ شروع را وارد نمایید.",
    },
    expireDate: {
      required: "لطفا تاریخ پایان را وارد نمایید.",
    },
    minAmount: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
    maxAmount: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
    minItems: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
    maxItems: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
    calculationType: {
      required: "لطفا نوع محاسبه را انتخاب نمایید.",
    },
    discountAmount: {
      required: "لطفا مقدار تخفیف را وارد نمایید.",
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  name: "saleManagement_Vouchers_Create",
  data() {
    return {
      calculationTypes: [
        { name: "مقداری", id: 1 },
        { name: "درصدی", id: 2 },
      ],
      model: {
        prefix: "",
        title: "",
        sponsorInfo: {
          id: 0,
        },
        expirationInfo: {
          startClock: "",
          expireClock: "",
        },
        discountLimitation: {
          minimumBasketAmount: null,
          maximumBasketAmount: null,
          minimumNumberOfItemsInBasket: null,
          maximumNumberOfItemsInBasket: null,
        },
        isItCalculatedForAnAmazingDiscount: false,
        discountType: null,
        discountAmount: null,
      },
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  components: {
    "v-select": vSelect,
    Treeselect,
  },
  methods: {
    ...mapActions({
      fetchSearch: "stock/fetchSearch",
      create: "voucher/create",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.stockId,
                  label: element.stockName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onProductSelected() {},
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.create(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
            })
            .then(() => this.$router.push("/Vouchers/Index"));
        }
      });
    },
  },
};
</script>
